import React, { useRef } from 'react';
import PropTypes from 'prop-types';

const Finarium = ({ userType, finariumToken, finariumUrl }) => {
  const iframeLoaded = useRef(false);
  const iframeRef = useRef();

  const sendToIframeFinarium = () => {
    if (iframeRef.current && iframeRef.current.contentWindow) {
      iframeRef.current.contentWindow.postMessage(
        {
          type: 'SET_TOKEN',
          token: finariumToken,
          tokenUserType: userType,
        },
        `${finariumUrl}/${userType}`
      );
    }
  };

  const IframeWithScopeFinarium = () => {
    const url = new URL(`${finariumUrl}/${userType}`);
    url.searchParams.append('scope', window.location.origin);
    const iframeUrl = url.toString();

    const handleIframeLoad = () => {
      iframeLoaded.current = true;
      if (finariumToken) {
        sendToIframeFinarium();
      }
    };

    return (
      <iframe
        ref={iframeRef}
        src={iframeUrl}
        onLoad={handleIframeLoad}
        style={{
          height: 'calc(100% - 18px)',
          width: 'calc(100% - 5px)',
          border: 'none',
          borderRadius: '8px',
          margin: '5px 5px 5px 0',
        }}
        sandbox='allow-same-origin allow-scripts allow-forms allow-popups allow-downloads allow-modals allow-popups-to-escape-sandbox allow-presentation allow-top-navigation-by-user-activation'
        allow='clipboard-write; clipboard-read'
      />
    );
  };

  return <div className='content'>{IframeWithScopeFinarium()}</div>;
};

Finarium.propTypes = {
  userType: PropTypes.string,
  finariumToken: PropTypes.string,
  finariumUrl: PropTypes.string,
};

export default Finarium;
